import React, { memo } from 'react'

import {
  getProfileAvatarSelector,
  getInitialsOfNameSelector,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'

import Avatar from 'components/ProfileAvatar'

const ProfileAvatar = ({ className = '', onClick }) => {
  const avatar = useShallowEqualSelector(getProfileAvatarSelector)
  const initials = useShallowEqualSelector(getInitialsOfNameSelector)

  return (
    <button
      className={`profile-avatar-container  ${className}`}
      onClick={onClick}
    >
      <Avatar
        className="avatar"
        src={avatar}
        alt="Profile Logo"
        initials={initials}
      />
    </button>
  )
}

export default memo(ProfileAvatar)
